import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {changeGroupField} from "../../../../../store/actions/groupFields";
import ParametersNotice from "../../Parameters/ParametersNotice";
import CustomTableNotice from '../../CustomTableNotice';

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	getField(name) {
		return [
			{
				name:   name,
				label:  name,
				fields: [
					getFieldFactory().getSourceField(), getFieldFactory().getValueInputType('input', 'Value'), getFieldFactory().getParametersField(), getFieldFactory().getDynamicField(),
					{
						id:           'type',
						inputType:    'select',
						source:       'serializedTypes',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Type to store',
						defaultValue: 'Select a data type',
						dynamic:      false
					}
				],
			}
		];
	}

	render() {

		const {addSubField, group, customTables} = this.props;

		return (<FieldGroupContext.Consumer>

				{({endpointId, endpoint, currentItem, action}) => (

					( endpoint[action][currentItem].tableSelection[0].fields[0].value === '') ?
						<CustomTableNotice/> :

					<React.Fragment>
						<h3>Columns ({endpoint[action][currentItem].defaultFields.length})</h3>

						<p>Use this section for define how the columns of the custom table will be updated.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<label>Select a column:</label>
						<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{customTables && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']] && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].map((el, index) => <option key={index}
																																																							   value={el}>{el}</option>)}
						</select>

						<button
							onClick={() => addSubField(endpointId, this.getField(customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].filter(el => el === this.state.selectedFilterToAdd)), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add a column
						</button>

						<FieldGroups group={group}/>

					</React.Fragment>)}

			</FieldGroupContext.Consumer>);
	}
}

const mapStateToProps = (state) => (state);

const mapDispatchToProps = dispatch => ({
	addSubField:      (endpointId, field, currentItem, group, parentGroup) => dispatch(addSubField(endpointId, field, currentItem, group, parentGroup)),
	changeGroupField: (endpointId, group, index, field, value) => dispatch(changeGroupField(endpointId, group, index, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultFieldsFilter);
